module.exports = __webpack_public_path__ + "static/media/Layout3.987ecc7d.png";